import { useState } from 'react'

import ViewDealerCreditChangeDtcOnlyCostModal from './ModalChangeDtcOnlyCost'
import Button from '../../../../components/Button'

const DEFAULT_DTC_ONLY_CREDIT_COST = 0.5

const formatCredits = (value) => {
  return Number.isInteger(value) ? `${value}` : `${value}`
}

const ViewDealerCreditDtcOnlyCost = ({ dealer, setDealer, socket }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleOnChangeSuccess = (dealerCredit) => {
    setDealer({ credit: { ...dealer.credit, ...dealerCredit } })
  }

  const effectiveCost =
    typeof dealer.credit.dtcCreditCostOverride === 'number'
      ? dealer.credit.dtcCreditCostOverride
      : DEFAULT_DTC_ONLY_CREDIT_COST

  return (
    <>
      <div className="px-6 pt-6 pb-6 space-y-3 sm:space-y-0 sm:flex sm:space-x-6 sm:items-center sm:justify-between">
        <h2 className="text-lg font-semibold tracking-tight mb-0.5">
          Subdealer DTC-only cost is {formatCredits(effectiveCost)} credit
          {effectiveCost === 1 ? '' : 's'}
        </h2>
        <Button onClick={() => setModalOpen(true)}>Change DTC-only cost</Button>
      </div>
      <ViewDealerCreditChangeDtcOnlyCostModal
        dtcCreditCostOverride={dealer.credit.dtcCreditCostOverride}
        isOpen={modalOpen}
        onSuccess={handleOnChangeSuccess}
        setIsOpen={() => setModalOpen(false)}
        socket={socket}
      />
    </>
  )
}

export default ViewDealerCreditDtcOnlyCost
